import React from 'react';
import { usePreferences } from '../state/usePreferences';

/**
 * The deadline passed, 30 days before the wedding. A couple who followed their
 * emailed link lands here rather than on the dashboard, so the page says why
 * the form is closed. Reopening it is ops work, asked for off the page.
 */
const ClosedNotice = () => {
  const { closed, reopenRequested } = usePreferences();
  if (!closed) return null;

  return React.createElement(
    'div',
    { className: 'cp-savewarn is-info cp-closed' },
    React.createElement(
      'span',
      null,
      'This form closed 30 days before your wedding, so it can no longer be edited.'
    ),
    reopenRequested
      ? React.createElement('span', { className: 'cp-closed-done' }, 'Reopen requested')
      : null
  );
};

export default ClosedNotice;
